import { ValidationService } from "aspnet-client-validation";
import { addWordCountProvider } from "@/validation/WordCountValidation";
import { addMustBeTrueProvider } from "@/validation/MustBeTrueValidation";
import { addFileSizeProvider } from "@/validation/FileSizeValidation";
import { addFileTypeProvider } from "@/validation/FileTypeValidation";

/** Shared global validation service instance */
export const validationService: ValidationService = new ValidationService();

export function initValidation()
{
    //Use Bootstrap's validation classes
    validationService.ValidationInputCssClassName = "is-invalid";
    validationService.ValidationInputValidCssClassName = "is-valid";
    validationService.ValidationMessageCssClassName = "invalid-feedback";
    validationService.ValidationMessageValidCssClassName = "valid-feedback";

    addWordCountProvider(validationService);
    addMustBeTrueProvider(validationService);
    addFileTypeProvider(validationService);
    addFileSizeProvider(validationService);

    validationService.bootstrap();
}
